<template>
  <div class="row-card">
    <Row :gutter="20" class="row-card">
      <Col span="6" class="row-card">
        <Card class="row-card">
          <Form
            ref="dataDetails"
            :model="dataDetails"
            :rules="rules"
            :label-width="80"
          >
            <FormItem :label="$t('type')" prop="classify">
              <RadioGroup v-model="dataDetails.classify">
                <Radio label="DELIVERY" border>DELIVERY</Radio>
                <Radio label="TO_WMS" border>TO_WMS</Radio>
              </RadioGroup>
            </FormItem>
            <FormItem :label="$t('order_number')" prop="transfer_number">
              <Input
                type="textarea"
                v-model="dataDetails.transfer_number"
                :placeholder="$t('enter') + $t('order_number')"
                :autosize="{ minRows: 15, maxRows: 15 }"
              >
              </Input>
            </FormItem>
            <div style="width:100%;text-align:center">
              <Button type="primary" @click="submitOk('dataDetails')">
                {{ $t("order_submit") }}
              </Button>
            </div>
          </Form>
        </Card>
      </Col>
      <Col span="18" class="row-card">
        <Card class="row-card">
          <vxe-table
            border
            stripe
            resizable
            height="100%"
            align="center"
            :data="list"
          >
            <vxe-column
              v-for="field in fields"
              :key="field.key"
              :field="field.key"
              :title="field.title"
              :min-width="field.minWidth"
              :width="field.width"
              align="center"
              headerAlign="center"
            >
            </vxe-column>
          </vxe-table>
        </Card>
      </Col>
    </Row>
  </div>
</template>

<script>
import { addPostPickup } from "@/api/operation_modules/pickup";
export default {
  name: "createPickup",
  data() {
    return {
      dataDetails: {},
      rules: {
        classify: [
          {
            required: true,
            message: "Please select the type",
            trigger: "change"
          }
        ],
        transfer_number: [
          {
            required: true,
            message: "transfer_number cannot be empty",
            trigger: "blur"
          }
        ]
      },
      list: [],
      fields: [
        {
          title: this.$t("order_number"),
          key: "transfer_number",
          minWidth: 160
        },
        {
          title: this.$t("pickupNumber"),
          key: "pickup_number",
          minWidth: 100
        },
        {
          title: this.$t("location"),
          key: "shelves_number",
          minWidth: 80
        },
        {
          title: this.$t("tip1"),
          key: "msg",
          minWidth: 80
        }
      ]
    };
  },
  methods: {
    submitOk(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          let data = {
            classify: this.dataDetails.classify,
            transfer_number: this.dataDetails.transfer_number
              .trim()
              .split(/\s+/)
          };
          this.$refs[name].resetFields();
          addPostPickup(data).then(res => {
            this.$Message[res.data.status ? "success" : "error"]({
              background: true,
              content: res.data.msg,
              duration: res.data.status ? 2 : 5
            });
            // if (res.data.status) {
            this.list = res.data.payload;
            // }
          });
        }
      });
    }
  }
};
</script>
<style>
.row-card {
  height: 100%;
}
.row-card > .ivu-card-body {
  height: calc(100% - 32px);
}
</style>
